var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",staticStyle:{"height":"100vh"}},[_c('div',{staticClass:"row align-items-center",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"col-md-5",staticStyle:{"height":"97%"}},[_c('search',{on:{"tablet-selected":_vm.onTabletSelected}})],1),_c('div',{staticClass:"col-md-7",staticStyle:{"height":"97%"}},[_c('text-view',{attrs:{"tablet_id":_vm.tablet_id}})],1)])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01a8398a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Explorer.vue
// module id = null
// module chunks = 